var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartBarClaimsLossRatio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "87px",
    height: "32px",
    viewBox: "0 0 87 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4D6EE9A1-27C8-4D09-ABF8-06F57B7A8124") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Visual-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage---Edit-Metrics---Alternate",
    transform: "translate(-1008.000000, -355.000000)",
    fill: "#337DC7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-119",
    transform: "translate(223.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-73",
    transform: "translate(61.000000, 78.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(663.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chart-bar-claims-loss-ratio",
    transform: "translate(61.000000, 69.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 26,
    width: 15,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 18,
    y: 17,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-15",
    x: 54,
    y: 17,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 36,
    y: 0,
    width: 15,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-23",
    x: 72,
    y: 0,
    width: 15,
    height: 32
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBarClaimsLossRatio);
export default __webpack_public_path__ + "static/media/chart-bar-claims-loss-ratio.086e93073f644d21911335671a195d34.svg";
export { ForwardRef as ReactComponent };